import type React from 'react'
import { Box, Stack, alpha } from '@mui/material'
import LoadingIndicator from '@/components/LoadingIndicator'

interface FilterLoadingOverlayProps {
  loading: boolean
  children: React.ReactNode
}

const FilterLoadingOverlay: React.FC<FilterLoadingOverlayProps> = ({ loading, children }) => {
  if (!loading) {
    return <>{children}</>
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {children}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: alpha('#fff', 0.5),
          backdropFilter: 'blur(1px)',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 2,
          borderRadius: 1,
        }}
      >
        <Stack spacing={2}>
          <LoadingIndicator />
        </Stack>
      </Box>
    </Box>
  )
}

export default FilterLoadingOverlay
